<script setup>
import { computed } from 'vue'

const props = defineProps({
  readingTime: {
    type: Number,
    required: true,
  },
  publishedAt: {
    type: [String, Date],
    required: true,
  },
})

const formattedDate = computed(() => {
  const date = new Date(props.publishedAt)
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
})
</script>

<template>
  <div class="article-meta">
    <div class="meta-item">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <circle
          cx="12"
          cy="12"
          r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
      <span>{{ readingTime }} minutes de lecture</span>
    </div>

    <div class="meta-item">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <rect
          x="3"
          y="4"
          width="18"
          height="18"
          rx="2"
          ry="2" />
        <line
          x1="16"
          y1="2"
          x2="16"
          y2="6" />
        <line
          x1="8"
          y1="2"
          x2="8"
          y2="6" />
        <line
          x1="3"
          y1="10"
          x2="21"
          y2="10" />
      </svg>
      <span>Publié le {{ formattedDate }}</span>
    </div>
  </div>
</template>

<style scoped>
.article-meta {
  display: inline-flex;
  align-items: center;
  gap: 1.5rem;
  padding: 0.75rem 1rem;
  background-color: #1a1a1a;
  border-radius: 6px;
  color: #ffffff;
  font-family:
    system-ui,
    -apple-system,
    sans-serif;
  font-size: 0.9rem;
}

.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.meta-item svg {
  width: 18px;
  height: 18px;
  color: #2196f3;
  flex-shrink: 0;
}
</style>
